import EnemyType from "../../enums/EnemyType";
import EnemyData from "./EnemyDataInterface";

const BOSS_ENEMYS: {
  [key in EnemyType]?: EnemyData[];
} = {
  [EnemyType.SUIT_HAMSTER]: [
    {
      level: 1, //doesn't seem to impact anything
      maxHp: 15,
      speed: 140,
      power: 10,
      skills: ["HPxLevel"],
      knockback: 1,
      deathKB: 2,
      killedAmount: 0,
      xp: 30,
      spriteName: "suit_hamster",
      animationKey: "suit_hamster_run",
      scale: 1.2,
    },
  ],
  [EnemyType.VAMPIRE_HAMSTER]: [
    {
      level: 5,
      maxHp: 40,
      speed: 150,
      power: 25,
      skills: ["HPxLevel"],
      knockback: 0.8,
      deathKB: 2,
      killedAmount: 0,
      xp: 30,
      spriteName: "vampire_hamster",
      animationKey: "vampire_hamster_run",
      scale: 1.5,
    },
  ],
  [EnemyType.LIZARD_HAMSTER]: [
    {
      level: 10,
      maxHp: 30,
      speed: 300,
      power: 20,
      knockback: 0.1,
      deathKB: 7,
      skills: ["HPxLevel"],
      killedAmount: 0,
      xp: 2.5,
      spriteName: "lizard_hamster",
      animationKey: "lizard_hamster_run",
      scale: 1.5,
    },
  ],
  [EnemyType.KING_HAMSTER]: [
    {
      level: 15,
      maxHp: 100,
      speed: 150,
      power: 40,
      skills: ["HPxLevel"],
      res_Freeze: 0.1,
      knockback: 0,
      deathKB: 5,
      killedAmount: 0,
      scale: 2,
      xp: 25,
      spriteName: "king_hamster",
      animationKey: "king_hamster_run",
    },
  ],
  [EnemyType.SCORPION_BOSS]: [
    {
      level: 1, //doesn't seem to impact anything
      maxHp: 20,
      speed: 200,
      power: 15,
      skills: ["HPxLevel"],
      knockback: 0.5,
      deathKB: 2,
      killedAmount: 0,
      xp: 30,
      spriteName: "scorpion",
      animationKey: "scorpion_run",
      scale: 2.5,
    },
  ],
  [EnemyType.GOLEM_BOSS]: [
    {
      level: 1, //doesn't seem to impact anything
      maxHp: 30,
      speed: 140,
      power: 30,
      skills: ["HPxLevel"],
      knockback: 0.2,
      deathKB: 2,
      killedAmount: 0,
      xp: 30,
      spriteName: "golem",
      animationKey: "golem_run",
      scale: 1.5,
    },
  ],
  [EnemyType.DEATH]: [
    {
      level: 666,
      maxHp: 6666,
      speed: 830,
      power: 999,
      skills: ["HPxLevel"],
      res_Freeze: 1,
      knockback: -0.1,
      deathKB: 5,
      killedAmount: 0,
      scale: 3.5,
      xp: 25,
      spriteName: "dude",
      animationKey: "dude_run",
    },
  ],
};
export default BOSS_ENEMYS;
